import React, {useState} from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch} from 'react-redux';
import { Divider, Loader } from 'rsuite';
import * as actionsUser  from '../../../../app/actions/user';
import {steppLabels} from './common/types';
import NuInsStepper from '../elements/NuInsStepper';
import {InfoIcon} from '../svg/iconsSvg';
import {FrameTwoIcon} from '../svg/iconFrameTwoSvg';

const PaymentConDSuccess = ({style}) => {

    const history = useHistory();
    const dispatch = useDispatch();

    const { revisedOffer } = useSelector(state => state.insOffers);

    const { insCompany, installments, installmentsLEVA } = revisedOffer || {}; // for testing
    const payAmount = installments ? Number.parseFloat(installments[0]).toFixed(2) : null;
    const payAmountLEVA = installmentsLEVA ? Number.parseFloat(installmentsLEVA[0]).toFixed(2) : null;

    const {registrationProps, initialData} = useSelector(state => state.insVehicleInfo) || {};
    const {make, model, plate} = registrationProps || {};
    const vechicleMake = make ? `${make.value} ${model?.value}` : null;
    const vechiclePlate = plate ? ` ${plate?.value}` : null;

    const {registered} = initialData || {};

    const [loading, setLoading] = useState(false);

    const infoTexts = ['Успешно завърши поръчка на полица с наложен платеж', 'Твоята полица е в процес на обработка', 'Ще получиш имейл когато полицата е готова',
                    insCompany === 'dallbogg' && !registered
                    ? 'При склюване на 1-годишна полица за нерегистрирано МПС е необходимо в 30 дневен срок да ни изпратиш талона на автомобила на help@nuins.io, за да не бъде прекратена полицата'
                    : null
                    ];

    const goToMyPolicy = async () => {

        setLoading(true);
        await dispatch(actionsUser.getMyPolicies());

        history.push("/app/my-policies");

    }

    const renderInfoTexts = () => {
        return infoTexts.filter(text => text).map((text, i) => {
                return <div className="steps_container-info" key={i+1}>
                            <div>
                                <InfoIcon size="20" style={{marginLeft: '2px'}}/>
                            </div>
                            <div>{text}</div>
                        </div>
        })
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <NuInsStepper activeStep={4} steps={4} labels={steppLabels}/>              
            </div>
            <Divider style={{marginBottom: 0 , backgroundColor: '#6bdfa7', height: '.5px'}}/>
            <div className="payment-card">
                <div className="left">
                    <p style={{marginBottom: '8px'}}>{vechicleMake}</p>
                    <p style={{}}>{vechiclePlate}</p>
                </div>
                <div className="right">
                <p style={{marginBottom: '8px', opacity: '.7'}}>Платена сума</p>
                <p style={{fontWeight: '700', fontSize: '15px', paddingLeft: '8px'}}>{payAmount} € / {payAmountLEVA} лв.</p>
                </div>
            </div>
            <div className="big-icon-container" style={{margin: '20px 0'}}>
                <FrameTwoIcon size={120}/>
            </div>
            {renderInfoTexts()}
    
            <button className="nuIns-btn nuIns-btn-main" style={{margin: '36px 0'}} onClick={goToMyPolicy}>Моите полици</button>           
            
            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}
        </div>
    )
}

export default PaymentConDSuccess;